import { Coordinate } from 'ol/coordinate';
import { GeoDataUtilities } from '@rogoag/shared-ts';
import { alertError } from './alertDispatcher';

/** Wrapper around shared-ts simplifyRingWithUTM that adapts [lat,lon] (OL) ↔ [lon,lat] (GeoJSON) */
export function simplifyPolygon(points: Coordinate[], tolerance: number, highestQuality: boolean) {
  const geojsonRing = points.map(([lat, lon]) => [lon, lat]);

  let simplified;

  try {
    simplified = GeoDataUtilities.simplifyRingWithUTM(geojsonRing, tolerance, highestQuality);
  } catch (e) {
    alertError('Error occurred while simplifying polygon');

    return points;
  }

  return simplified.map(([lon, lat]) => [lat, lon]);
}
